import { createCanvas } from '@/utils/file-kit';
import { ISize } from '@/version-types';

/**
 * 通过 SVG 合成蒙版
 *
 * @param svg - SVG 字符串
 * @param size - 蒙版尺寸
 * @returns 合成后的 Canvas 对象
 */
export function createMaskFromSVG(svg: string, size: ISize): Promise<HTMLCanvasElement> {
    return new Promise((resolve, reject) => {
        const { canvas, ctx } = createCanvas(size.width, size.height);
        const svgURL = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
        let svgElement: HTMLImageElement | null = document.createElement('img');

        svgElement.src = svgURL;
        svgElement.onload = () => {
            ctx.drawImage(svgElement!, 0, 0, size.width, size.height);
            URL.revokeObjectURL(svgURL);
            svgElement = null;
            resolve(canvas);
        };

        svgElement.onerror = () => {
            reject(new Error('Failed to load SVG'));
        };
    });
}
